import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import { sizes } from 'Styles/sizes'
import React from 'react'
import styled from 'styled-components'
import Button from '../../../Components/Base/Button'

interface Props {
  onSubmit: () => void
}
export default function WelcomeForm({ onSubmit }: Props) {
  return (
    <>
      <div className="intake-form-container">
        <Typography className="intake-header">Patient Intake Form</Typography>
        <div style={{ marginBottom: 15 }}>
          <Typography size={24}>
            To help our pharmacists provide you with the best care, please take a few moments to fill out this intake form.{' '}
            <b>It should take less than 10 minutes.</b>
          </Typography>
          <Typography size={24} styles={{ marginTop: 20 }}>
            <b>Make sure to have a list of your medications handy.</b> Rest assured, all your information will be kept confidential. If you have any
            questions, feel free to call the Tria Health Help Desk: 1.888.799.8742
          </Typography>
        </div>

        <Row center>
          <StyledButton pageName="patient_intake_welcome" text="Get Started!" onClick={onSubmit} />
        </Row>
      </div>
    </>
  )
}

const StyledButton = styled(Button)`
  border-radius: 4px;
  padding: 11px 0px;
  width: 200px;
  @media (max-width: ${sizes.tablet}) {
    margin-right: 0px;
    width: 100%;
  }
`
